import { GoogleSubscriptions } from "../../../model";
import { apiService } from "../../ApiService";

export const googleSubscribeUpdate = (googleSubscriptions: GoogleSubscriptions) => {
  return apiService.put<unknown>({
    path: `v1/store/google_play/subscription`,
    body: {
      ...googleSubscriptions,
    },
    requiresAuthPolicy: undefined,
  });
};
